import React from 'react';

/**
 * App-level error boundary. Prevents a blank white screen when a rendering
 * error occurs — shows a friendly Turkish message with a reload action and
 * logs the error to the console for debugging.
 */
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('UI ErrorBoundary caught:', error, info);
  }

  handleReload = () => {
    this.setState({ hasError: false });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="min-h-screen flex flex-col items-center justify-center bg-background text-foreground px-6 text-center"
          data-testid="error-boundary"
        >
          <div className="w-14 h-14 rounded-2xl bg-[hsl(var(--gold)/0.12)] flex items-center justify-center mb-5">
            <span className="text-2xl">⚠</span>
          </div>
          <h1 className="font-heading text-2xl font-semibold mb-2">Bir şeyler ters gitti</h1>
          <p className="text-sm text-muted-foreground max-w-md mb-6">
            Beklenmedik bir hata oluştu. Lütfen sayfayı yenileyin. Sorun devam ederse kısa bir süre sonra tekrar deneyin.
          </p>
          <button
            onClick={this.handleReload}
            className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-[hsl(var(--gold))] text-[hsl(var(--accent-foreground))] text-sm font-medium hover:bg-[hsl(var(--gold)/0.92)] active:scale-[0.98] transition-colors"
            data-testid="error-boundary-reload-button"
          >
            Sayfayı Yenile
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
